import { Badge } from "../Badge";
import { AwardCard, type AwardCardProps } from "./AwardCard";

export function TimelineItem({
  school,
  study,
  period,
  merit,
  upcoming,
  awards,
}: {
  school: string;
  study: string;
  period: { start: number; end: number };
  merit?: boolean;
  upcoming?: boolean;
  awards?: AwardCardProps[];
}) {
  return (
    <div>
      <div>
        <div className='flex items-center grow'>
          {/* Timeline dot */}
          <div className='absolute w-3 h-3 bg-base-100 rounded-full border left-0 -start-1 flex items-center'>
            <p className='text-lg font-medium -ml-32 text-end hidden sm:block'>
              {period.start} - {period.end}
            </p>
          </div>
          <div className='flex gap-6 items-center'>
            <div>
              <h4 className='text-2xl font-semibold mb-2'>{school}</h4>
              <p className='text-base-content/90'>{study}</p>
              {merit && <Badge text='Graduated with Merit' className='text-xs text-secondary mt-3 mr-2' />}
              {upcoming && <Badge text='Upcoming' className='text-xs bg-warning text-warning-content mt-3 mr-2' />}
              <Badge className='sm:hidden text-base-content/90 mt-3' text={`${period.start} - ${period.end}`} />
            </div>
            <div>{/* <Badge text='2021 - 2024' /> */}</div>
          </div>
        </div>
      </div>
      {/* Awards */}
      <div className='grid grid-cols-1 lg:grid-cols-2 4xl:grid-cols-3 gap-6 items-center justify-between flex-wrap mt-12'>
        {awards?.map((award, index) => (
          <AwardCard
            key={index}
            name={award.name}
            description={award.description}
            years={award.years}
            highlight={award.highlight}
            icon={award.icon}
          />
        ))}
      </div>
    </div>
  );
}
